import React from "react";

import { registerForLocalization } from "@progress/kendo-react-intl";

export const Localization = ({ messageKey, defaultMessage, replaceNewLines = false, args = [] }, context) => {
    const localizationService = context.kendoLocalizationService;

    function getLocalizationMessage() {
        var message = localizationService.toLanguageString(messageKey, defaultMessage);
        if (replaceNewLines) {
            message = message.replace("\r\n", "<br/>");
            message = message.replace("\n", "<br/>");
        }
        if (args.some) {
            for (let i = 0; i < args.length; i++) {
                message = message.replace(`{${i}}`, args[i]);
            }
        }
        return message;
    }

    return replaceNewLines ? <span dangerouslySetInnerHTML={{ __html: getLocalizationMessage() }} /> : <span>{getLocalizationMessage()}</span>;
};

registerForLocalization(Localization);



// WEBPACK FOOTER //
// ./src/components/common/Localization.js